/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import ProcessCategoryCreateDialog from "../dialogTypes/ProcessCategoryCreateDialog";

function ProcessCategoryCreateButton ( props ) {
    const {t} = useTranslation();
    const {id, schema, refresh, selectMstGrid, onSuccess, ...others} = props;
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();

    const onOpen = () => {
        if(selectMstGrid) {
            setFormData(selectMstGrid);
        }
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess (msg);
        }
        refresh.refresh ();
    };

    return (
        <>
            <CreateRecordButtonLayout id={id+"append-button"} onClick={onOpen} {...others} />
            <ProcessCategoryCreateDialog
                id={id+"append-dialog"}
                title={t(`dialog.title.${schema.name}.create`)}
                schema={schema}
                open={open}
                onClose={onClose}
                initialData={formData}
                onSuccess={onCreateSuccess}
            />
        </>
    );
}

export default ProcessCategoryCreateButton;

